export interface IProtectionPlanIDFState {
    isLoading: boolean;
    protectionPlanData: IProtectionPlanResponse;
}

export const REQUEST_PROTECTION_PLAN_IDF = "REQUEST_IDF_PROTECTION_PLAN";
export const RECEIVE_PROTECTION_PLAN_IDF = "RECEIVE_IDF_PROTECTION_PLAN";

export interface IRequestProtectionPlanAction {
    type: typeof REQUEST_PROTECTION_PLAN_IDF;
}

export interface IReceiveProtectionPlanAction {
    protectionPlanData: IProtectionPlanResponse;
    type: typeof RECEIVE_PROTECTION_PLAN_IDF;
}

export interface IProduct {
    id?: number;
    name?: string;
    serviceCode?: string;
    /*--can be changed based on response--*/
    groupName?: string;
    productDescription: string;
}

export interface IPackageProduct {
    id?: number;
    serviceCode?: string;
    productName?: string;
    icon?: string;
    groupName?: string;
}

export interface ICancellationStatus {
    cancellationDate?: string;
    processedDate?: string;
    requestedDate?: string;
}

export interface IProductGroup {
    name: string;
}

export interface IPackage {
    IsActive?: boolean;
    id: number;
    name: string;
    code: string;
    "annual-cost": number;
    "monthly-cost": number;
    "upgrade-order": number;
    "upgrade-cost": number;
    "total-offer-cost": number;
    "billing-cycle": string;
    productDifference: IPackageProduct[];
    products: IPackageProduct[];
    isCancellable: boolean;
    providedBy: string;
    isUserPaid: boolean;

    /* for UI purpose */
    ActionButtonText?: string;
    Price?: number;
    DisplayCancelButton?: boolean;
}

export type ProtectionPlanTypes = IRequestProtectionPlanAction | IReceiveProtectionPlanAction;

export interface IProtectionPlanResponse {
    packageList?: IPackage[];
    productList?: IProduct[];
    cancellationStatus?: ICancellationStatus;
}

//==================================BillingInfoState====================================================================
export interface IBillingInfoState {
    isLoading: boolean;
    billingInfoData?: IBillingInfoResponse;
}
export const REQUEST_BILLING_INFO = "REQUEST_BILLING_INFO";
export const RECEIVE_BILLING_INFO = "RECEIVE_BILLING_INFO";

export interface IRequestBillingInfoAction {
    type: typeof REQUEST_BILLING_INFO;
}

export interface IReceiveBillingInfoAction {
    data: IBillingInfoResponse;
    type: typeof RECEIVE_BILLING_INFO;
}

export interface IBillingInfoResponse {
    creditCard?: ICreditCard;
    nextBillingDate?: string;
}

export interface ICreditCard {
    cardType?: any;
    nameOnCard: string;
    cardNumber: string;
    expDateMo?: string;
    expDateYr?: string;
    securityCode?: string;
    countryId?: number;
    expirationDate?: string;
    billingZip?: string;
}

export type BillingInfoTypes = IRequestBillingInfoAction | IReceiveBillingInfoAction;
